import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('home');

/**
 * 获取首页模块列表
 * @param {*} conditions
 */
export function getHomeModuleData(conditions) {
  return jrequest('module', conditions);
}

/**
 * 获取首页分类列表
 */
export function getClassFicationData(conditions) {
  return jrequest('class', conditions);
}

/**
 * 获取首页广告信息
 * @param {*} conditions
 */
export function getHomeAdConfig() {
  return jrequest('ad/config');
}

/**
 * 获取商品详情广告
 * @param {*} conditions
 */
export function getGoodsDetailAd(conditions) {
  return jrequest('goods/ad', conditions);
}
